import assign from 'lodash.assign'

import { SET_LOCATION } from './location'
import { trackEvent } from '../utils/tracking'

//
// ACTION TYPES
//

const CLOSE_MENU = 'CLOSE_MENU'
const SHOW_MENU = 'SHOW_MENU'

//
// INITIAL STATE
//

const intialState = {
  isShowing: false,
  showNotification: false
}

//
// REDUCER
//

export default function menu (state = intialState, action) {
  switch (action.type) {
    case SHOW_MENU:
      return assign({}, state, {
        isShowing: true
      })
    case CLOSE_MENU:
    case SET_LOCATION:
      return assign({}, state, {
        isShowing: false
      })
    default:
      return state
  }
}

//
// ACTIONS
//

export function closeMenu () {
  trackEvent('closeMenu')
  return { type: CLOSE_MENU }
}

export function showMenu () {
  trackEvent('showMenu')
  return { type: SHOW_MENU }
}



// WEBPACK FOOTER //
// ./frontend/scripts/reducers/menu.js